import { DirectLinkStatus } from '@src/domains/direct-links';
import { OrderStatus } from '@src/domains/orders';
import { SaleChangeStatusEnum, SaleState } from '@src/domains/sales';
import type { Transactable } from '@src/domains/transactables/types/transactable';

/**
 * Whether the charge in play went through. `isTransactablePaymentComplete` answers for the group:
 * past the sale change, any of the order, the sale or the link being paid is enough, which is what
 * the success screen needs. This one follows the precedence of `resolveTransactableEntity` all the
 * way down — with an order in play, a sale paid before it says nothing about this charge.
 */
export const isTransactableSettled = (tr: Transactable): boolean => {
  if (tr.saleChange) {
    return tr.saleChange.status === SaleChangeStatusEnum.Applied;
  }

  if (tr.order) {
    return tr.order.status === OrderStatus.Confirmed;
  }

  if (tr.sale) {
    return tr.sale.state === SaleState.PaymentComplete;
  }

  if (tr.directLink) {
    return tr.directLink.status === DirectLinkStatus.PaymentComplete;
  }

  return false;
};
